import { render, staticRenderFns } from "./ImageInputOptimized.vue?vue&type=template&id=4fb95fb6&lang=pug"
import script from "./ImageInputOptimized.vue?vue&type=script&lang=js"
export * from "./ImageInputOptimized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports